import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../core/guards/auth-guard.service';
import { DetailBeneficiaireComponent } from './beneficiaires/detail-beneficiaire/detail-beneficiaire.component';
import { ListBeneficiaireComponent } from './beneficiaires/list-beneficiaire/list-beneficiaire.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { DetailMissionPlaceComponent } from './mission-place/detail-mission-place/detail-mission-place.component';
import { ListMissionPlaceComponent } from './mission-place/list-mission-place/list-mission-place.component';
import { DetailEmployeeComponent } from './employees/detail-employee/detail-employee.component';
import { ListEmployeeComponent } from './employees/list-employee/list-employee.component';
import { MapComponent } from './map/map/map.component';
import { PlanningComponent } from './planning/planning/planning.component';
import { ProfileComponent } from './profile/profile/profile.component';
import { ListSpecialiteComponent } from './specialites/list-specialite/list-specialite.component';
import { ListVehiculeComponent } from './vehicules/list-vehicule/list-vehicule.component';
import { DetailVehiculeComponent } from './vehicules/detail-vehicule/detail-vehicule.component';
import { HasVehicleAccessGuard } from '../core/guards/has-vehicle-access.guard';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { AuthorityGuard } from '../core/guards/authority.guard';
import { Authority } from '../shared/models/security/authority';
import { ListFormationComponent } from './formations/list-formation/list-formation.component';
import { DetailFormationComponent } from './formations/detail-formation/detail-formation.component';
import { IsMissionRequestDetailAllowedGuard } from '../core/guards/is-mission-request-detail-allowed.guard';
import { ListAreaComponent } from './area/list-area/list-area.component';
import { DetailAreaComponent } from './area/detail-area/detail-area.component';
import { ListMissionTypeComponent } from './mission-types/list-mission-type/list-mission-type.component';
import { UserInfosComponent } from './profile/user-infos/user-infos.component';
import { MessagerieComponent } from './messagerie/messagerie.component';
import { DailyRoutesComponent } from './routes/daily-routes/daily-routes.component';
import { ListRoutesComponent } from './routes/list-routes/list-routes.component';
import { ListFunderComponent } from './funders/list-funder/list-funder.component';
import { DetailMeetingComponent } from './formations/detail-meeting/detail-meeting.component';
import { ReportsComponent } from './reports/reports.component';
import { PrescriberBookingComponent } from './prescriber-booking/prescriber-booking/prescriber-booking.component';
import { ListCareskillComponent } from './careskills/list-careskill/list-careskill.component';
import { ListCenterDepartmentComponent } from './center-departments/list-center-department/list-center-department.component';
import { DetailCenterDepartmentComponent } from './center-departments/detail-center-department/detail-center-department.component';
import { ListParcoursComponent } from './parcours/list-parcours/list-parcours.component';
import { DetailParcoursComponent } from './parcours/detail-parcours/detail-parcours.component';
const routes: Routes = [
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: 'gestion',
		children: [
			{
				path: 'employees',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.PROFESSIONNEL_SAE
					]
				},
				children: [
					{
						path: 'list',
						component: ListEmployeeComponent
					},
					{
						path: ':id',
						component: DetailEmployeeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'beneficiaires',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.CHARGE_MISSION
					]
				},
				children: [
					{
						path: 'list',
						component: ListBeneficiaireComponent
					},
					{
						path: ':id',
						component: DetailBeneficiaireComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'parcours',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.CHARGE_MISSION,
						Authority.PROFESSIONNEL_SAE
					]
				},
				children: [
					{
						path: 'list',
						component: ListParcoursComponent
					},
					{
						path: ':id',
						component: DetailParcoursComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'mission-places',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.CHARGE_MISSION,
						Authority.PROFESSIONNEL_SAE
					]
				},
				children: [
					{
						path: 'list',
						component: ListMissionPlaceComponent
					},
					{
						path: ':id',
						component: DetailMissionPlaceComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'specialites',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListSpecialiteComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'expertises',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListCareskillComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'vehicules',
				canActivate: [AuthGuardService, HasVehicleAccessGuard, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListVehiculeComponent
					},
					{
						path: ':id',
						component: DetailVehiculeComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'formations',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR,
						Authority.CHARGE_MISSION,
						Authority.PROFESSIONNEL_SAE
					]
				},
				children: [
					{ path: '', pathMatch: 'full', redirectTo: 'list' },
					{
						path: 'list',
						component: ListFormationComponent,
						children: [
							{
								path: 'add',
								component: ListFormationComponent,
								data: { openModal: true }
							}
						]
					},
					{
						path: 'add',
						component: ListFormationComponent,
						data: { openModal: true }
					},
					{
						path: ':id',
						component: DetailFormationComponent,
						canActivate: [IsMissionRequestDetailAllowedGuard]
					}
				]
			},
			{
				path: 'meeting',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{ path: '', pathMatch: 'full', redirectTo: 'list' },
					{ path: 'list', component: ListFormationComponent },
					{
						path: ':id',
						component: DetailMeetingComponent
					}
				]
			},
			{
				path: 'areas',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListAreaComponent
					},
					{
						path: ':id',
						component: DetailAreaComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'services',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListCenterDepartmentComponent
					},
					{
						path: ':id',
						component: DetailCenterDepartmentComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			},
			{
				path: 'mission',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'type/list',
						component: ListMissionTypeComponent
					},
					{ path: '', redirectTo: 'type/list', pathMatch: 'full' }
				]
			},

			{
				path: 'funders',
				canActivate: [AuthGuardService, AuthorityGuard],
				data: {
					roles: [
						Authority.DIRECTEUR_STRUCTURE,
						Authority.RESPONSABLE_CENTRE,
						Authority.PLANIFICATEUR
					]
				},
				children: [
					{
						path: 'list',
						component: ListFunderComponent
					},
					{ path: '', redirectTo: 'list', pathMatch: 'full' }
				]
			}
		]
	},
	{
		path: 'prescriber/booking',
		component: PrescriberBookingComponent,
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [Authority.PRESCRIPTEUR]
		}
	},
	{
		path: 'planning',
		component: PlanningComponent,
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.INTERVENANT,
				Authority.PROFESSIONNEL_SAE
			]
		}
	},
	{
		path: 'map',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR
			]
		},
		children: [
			{
				path: ':id',
				component: MapComponent
			},
			{
				path: '',
				component: MapComponent
			}
		]
	},
	{
		path: 'espace-perso',
		component: ProfileComponent,
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.INTERVENANT,
				Authority.PROFESSIONNEL_SAE
			]
		},
		children: [
			{ path: 'securite', component: ChangePasswordComponent },
			{ path: 'profil', component: UserInfosComponent },
			{ path: '', redirectTo: 'profil', pathMatch: 'full' }
		]
	},
	{
		path: 'routes',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR
			]
		},
		children: [
			{ path: 'etude', component: DailyRoutesComponent },
			{ path: 'attente', component: DailyRoutesComponent },
			{ path: 'en-cours', component: DailyRoutesComponent },
			{ path: 'list', component: ListRoutesComponent },
			{ path: '', redirectTo: 'list', pathMatch: 'full' }
		]
	},
	{
		path: 'messagerie',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.INTERVENANT,
				Authority.PROFESSIONNEL_SAE
			]
		},
		component: MessagerieComponent
	},

	{
		path: 'reports',
		canActivate: [AuthGuardService, AuthorityGuard],
		data: {
			roles: [
				Authority.DIRECTEUR_STRUCTURE,
				Authority.RESPONSABLE_CENTRE,
				Authority.PLANIFICATEUR,
				Authority.CHARGE_MISSION,
				Authority.PROFESSIONNEL_SAE
			]
		},
		component: ReportsComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProtectedRoutingModule {}
